import { isAxiosError } from 'axios'

const DEFAULT_MAINTENANCE_MESSAGE =
  'Application is under maintenance. Please try again later.'

type MaintenancePayload = {
  data?: {
    code?: string
    message?: string
    maintenance_mode?: boolean
  }
}

const isMaintenancePayload = (
  payload: unknown
): payload is MaintenancePayload => {
  if (!payload || typeof payload !== 'object') return false
  const maybeData = (payload as MaintenancePayload).data
  return !!maybeData && maybeData.code === 'MAINTENANCE_MODE'
}

export const getMaintenancePayload = (
  error: unknown
): MaintenancePayload | undefined => {
  if (isMaintenancePayload(error)) {
    return error
  }

  if (!isAxiosError(error)) return undefined
  return error.response?.data as MaintenancePayload
}

export const isMaintenanceModeError = (error: unknown): boolean => {
  if (isMaintenancePayload(error)) return true
  if (!isAxiosError(error)) return false
  const payload = getMaintenancePayload(error)
  const maintenanceCode = payload?.data?.code === 'MAINTENANCE_MODE'
  return error.response?.status === 503 && maintenanceCode
}

export const getMaintenanceMessage = (error: unknown): string => {
  const payload = getMaintenancePayload(error)
  return payload?.data?.message?.trim() || DEFAULT_MAINTENANCE_MESSAGE
}
